/**
 * Changelog ของระบบ — แสดงมุมล่างของ sidebar (owner/HR/หัวหน้า) ให้รู้ว่าตอนนี้
 * version ไหน อัปเดตอะไรล่าสุดเมื่อไหร่. เพิ่ม entry ใหม่ไว้ "บนสุด" ทุกครั้งที่ deploy.
 * APP_VERSION / รายการล่าสุด = CHANGELOG[0].
 */
export interface ChangelogEntry {
  version: string;
  date: string;   // "17 มิ.ย. 2569"
  time: string;   // "21:38"
  items: string[];
}

export const CHANGELOG: ChangelogEntry[] = [
  {
    version: '1.36.0',
    date: '28 ส.ค. 2569',
    time: '23:00',
    items: [
      'นำเข้าไฟล์เงินเดือน: กรอกเงินเดือนเป็น 0 แล้วไม่มียอดอื่นในแถวนั้น = ไม่จ่ายคนนั้นงวดนี้ (เท่ากับไม่มีชื่อในไฟล์) — เดิมระบบข้ามช่อง 0 แล้วไปจ่ายตามฐานเงินเดือนเดิมให้เต็มจำนวน · ถ้าแถวนั้นมียอดอื่นอยู่ (เช่นค่าคอมล้วน) จะยังคิดเงินให้ตามยอดที่กรอก ไม่ถูกพัก · กล่องยืนยันบอกก่อนกดทุกครั้งว่าพักใครบ้าง',
      'รันร่างเงินเดือน: คนที่ถูก "พักไม่คิดเงินเดือนงวดนี้" จะไม่ถูกคิดเงินอีกต่อไป แม้จะเคยสรุปเวลาไว้ก่อนแล้ว และยอดร่างเดิมของเขาจะถูกลบให้ พร้อมขึ้นคำเตือนบอกว่าตัดใครออกเพราะอะไร — เดิมถ้าเอาชื่อออกจากไฟล์หลังกดสรุปเวลาไปแล้ว คนนั้นยังได้เงินอยู่เงียบ ๆ',
      'หน้าสรุปเวลา: ช่อง "ประมวลผลพนักงาน" กับ "พบรายการผิดปกติใหม่" เคยขึ้นเป็นค่าว่างมาตลอด (หน้าจออ่านชื่อค่าไม่ตรงกับที่ระบบส่งมา และตัวเลขรายการผิดปกติไม่เคยถูกส่งมาเลย) ตอนนี้ขึ้นเลขจริงแล้ว + บอกด้วยถ้าร่างเงินเดือนที่เคยอนุมัติถูกดึงกลับเป็นร่าง',
      'แก้ค้าง: กด "สรุปเวลาเข้างาน" แล้วขึ้น "บันทึกรายการผิดปกติไม่สำเร็จ" ทุกครั้ง — ตัวออกเลขที่รันของการ์ดรายการผิดปกติมองไม่เห็นการ์ดที่มีอยู่แล้วของวันนั้น เลยแจกเลขซ้ำแล้วชนกันเอง ตอนนี้นับต่อจากของเดิมถูกต้องแล้ว (มีผลกับใบลาฉุกเฉินที่ออกการ์ดด้วยเหมือนกัน)',
      'สรุปเวลาเข้างานเร็วขึ้นมาก — เดิมอ่านเลขการ์ดใหม่ทุกคนทุกวัน (พนักงาน 100 คน = อ่านซ้ำหลักพันครั้ง) ตอนนี้อ่านครั้งเดียวต่อวันแล้วนับต่อในหน่วยความจำ',
      'รันร่างเงินเดือน: ถ้ายังมีคนที่ไม่มีสรุปเวลาของงวดนั้น ระบบจะหยุดและบอกว่าขาดกี่คน รหัสอะไรบ้าง ให้กด "สรุปเวลาเข้างาน" ก่อน — เดิมจะข้ามคนกลุ่มนี้ไปเงียบ ๆ (ไม่ใช่จ่าย 0 แต่คือไม่มีบรรทัดของเขาในงวดเลย) ทำให้ยอดรวมขาดโดยไม่มีอะไรเตือน',
      'นำเข้าไฟล์เงินเดือน: ลบยอดหักออกจากไฟล์แล้วมีผลจริง — เดิมถ้าคนไหนถูกล้างยอดจนเป็น 0 ทุกช่อง รายการหักจากไฟล์รอบก่อนของเขาจะค้างอยู่ในระบบและถูกหักซ้ำ',
      'เทมเพลตเงินเดือนเพิ่มคอลัมน์ "ยอดจ่ายเดือนนี้" — กรอกแล้วระบบจ่ายยอดนั้นตรง ๆ ไม่เฉลี่ยตามวัน/ไม่หักขาดงาน/ไม่บวก OT ให้ (ช่อง "เงินเดือน" คือฐานที่ระบบเอาไปคิดต่อ) และสูตรสุทธิในไฟล์คิดตามยอดนี้ให้เห็นก่อนนำเข้า',
      'กล่องยืนยันก่อนนำเข้าเตือนเพิ่ม 2 อย่าง: คนที่กรอกเงินเดือนเป็น 0 (ระบบจะไม่ตั้งให้ และยังคิดเงินตามฐานเดิม) และคนที่เงินเดือนมีเศษสตางค์ (มักเป็นยอดที่เฉลี่ยวันมาแล้ว ควรย้ายไปช่องยอดจ่ายเดือนนี้)',
    ],
  },
  {
    version: '1.35.0',
    date: '18 ส.ค. 2569',
    time: '17:35',
    items: [
      'แท็บ "ใบเตือน" ในหน้าแก้ไขพนักงาน — HR อัปโหลด/ดูใบเตือนของพนักงานรายคน และพนักงานเห็นของตัวเองในเอกสารของฉัน',
    ],
  },
  {
    version: '1.34.0',
    date: '18 ส.ค. 2569',
    time: '16:40',
    items: [
      'ร้องเรียน/แจ้งเหตุ: ถ้าเจ้าของตั้งค่าลิงก์ LINE OA ของฝ่ายบุคคลไว้ (หน้าตั้งค่า → แท็บบริษัท) เมนู "ร้องเรียน/แจ้งเหตุ" ของพนักงานจะเปิดแชท LINE OA นั้นแทนหน้าร้องเรียนในระบบ — เว้นว่างไว้ ระบบทำงานแบบเดิมทุกอย่าง',
      'นโยบาย/ประกาศการทำงาน: เพิ่มหน้าจอแจ้งเมื่อไม่มีประกาศหรือโหลดข้อมูลไม่สำเร็จ (เดิมถ้าตารางมีปัญหา หน้าจะขึ้นรายการว่างเงียบ ๆ โดยไม่บอกอะไร) และเพิ่มเข้าเมนูค้นหาแล้ว',
      'เอกสารตามอายุงาน: เพิ่มการ์ดสรุปสถานะเซ็นสัญญาแยกตามประเภท (จ้างบริการ 1 เดือน / ทดลองงาน 3 เดือน / พนักงานประจำ) บอกจำนวนคนที่ยังไม่เซ็น กดดูรายชื่อได้ แยกป้าย "รอเซ็น" กับ "ยังไม่มีเอกสาร" ให้ชัดเจน · หน้าอัปโหลดเอกสารเพิ่มประเภทเอกสารใหม่ให้เลือกอีก 3 แบบ',
    ],
  },
  {
    version: '1.33.1',
    date: '15 ส.ค. 2569',
    time: '18:00',
    items: [
      'แก้ค้าง: คนที่อยู่ "กะยืดหยุ่น" ที่เริ่มบ่าย/ค่ำ (เช่น 16:00) ยังโดนเตือนสแกนเข้างานตอนเช้า 08:45 อยู่ — ตอนนี้กะยืดหยุ่นยึดเวลากะจริงแล้วเหมือนกะปกติ ถ้า HR ตั้ง "ต้องสแกนเข้าภายใน" ไว้ ระบบจะเตือนตามเวลานั้น ถ้าไม่ได้ตั้งจะใช้เวลาเริ่มกะ',
      'กะยืดหยุ่นที่ไม่บังคับสแกนออก จะไม่โดนตามให้สแกนเลิกงานอีก',
      'เวลากะที่กรอกมาแบบมีวินาที (16:00:00) หรือติดช่องว่าง ระบบอ่านได้แล้ว — เดิมอ่านไม่ออกแล้วเงียบ ๆ ไปใช้เวลาเข้างานของบริษัทแทน',
      'กันเตือน "เลิกงาน" ก่อนเวลาเข้างานของคนนั้น',
    ],
  },
  {
    version: '1.33.0',
    date: '14 ส.ค. 2569',
    time: '18:45',
    items: [
      'HR ลงเวลาย้อนหลังให้พนักงานที่ลืมสแกนได้เองแล้ว — ในหน้า "ประวัติเข้างานรายคน" เลือกพนักงาน วันที่ รอบ (เข้างาน/เลิกงาน/พักเที่ยง) และเวลา พร้อมเหตุผล ระบบแจ้งพนักงานทาง LINE ทุกครั้งว่า HR ลงเวลาให้ และบันทึกไว้ในประวัติการใช้งานระบบ',
      'งวดที่ปิดงวด/จ่ายเงินแล้ว จะลงเวลาย้อนหลังหรืออนุมัติคำขอรับรองเวลาไม่ได้ — กันหลักฐานเวลาไม่ตรงกับเงินที่จ่ายไปแล้ว',
      'พนักงานได้รับแจ้งทาง LINE เมื่อคำขอรับรองเวลาได้รับอนุมัติหรือถูกปฏิเสธ (เดิมต้องเข้ามาเช็คเอง)',
      'แก้การรับรองเวลาเลิกงานของกะข้ามเที่ยงคืน (เช่นกะ 16:00-01:00) ให้ลงเป็นเวลาหลังเที่ยงคืนของวันถัดไปถูกต้อง',
    ],
  },
  {
    version: '1.32.1',
    date: '14 ส.ค. 2569',
    time: '17:30',
    items: [
      'แจ้งเตือนสแกนเข้างานยึด "เวลาเริ่มกะจริง" ของแต่ละคนแล้ว — คนกะบ่าย/กะดึก (เช่นเริ่ม 16:00) จะไม่โดนเตือนตอนเช้า 08:30 ทุกวันอีก (เดิมใช้เวลาเข้างานของบริษัทกับทุกคน)',
      'แจ้งเตือนสแกนเลิกงานยึดเวลาเลิกกะจริงของแต่ละคน — กะที่เลิกหลังเที่ยงคืนจะไม่ถูกเตือนเลิกงานผิดวัน (ถ้าลืมสแกนออก ระบบทวงตอน 08:00 เช้าวันถัดไปเหมือนเดิม)',
      'คนที่ช่วงกะไม่คร่อมเวลาพักเที่ยงของบริษัท จะไม่โดนเตือนสแกนพักเที่ยง',
    ],
  },
  {
    version: '1.32.0',
    date: '13 ส.ค. 2569',
    time: '13:55',
    items: [
      'พนักงานทุกคนดูตารางเวรของทีมตัวเองได้แล้ว — เมนูใหม่ "ตารางเวรทีม" ในหน้าแรก เห็นว่าวันไหนใครเข้าเวรบ้าง (ดูอย่างเดียว แก้ไม่ได้ และไม่เห็นว่าเพื่อนลาด้วยเรื่องอะไร)',
      'หัวหน้าทีมดูตารางเวรได้ทุกคนทุกแผนกแล้ว (เดิมเห็นเฉพาะลูกทีมสายตัวเอง) — ส่วนการ "แก้เวร" ยังจำกัดเฉพาะลูกทีมของตัวเองเหมือนเดิม',
      'ปฏิทินเวรเลือกช่วงวันที่เองได้ จากวันไหนถึงวันไหน ข้ามเดือนได้ (เดิมเลื่อนได้ทีละเดือนเต็มเท่านั้น) — เลือกได้ครั้งละไม่เกิน 92 วัน',
      'ตัวกรองแผนกและตำแหน่งเลือกได้พร้อมกันหลายอัน (เดิมเลือกได้ทีละอัน)',
      'ช่องวันหยุดในปฏิทินเปลี่ยนเป็นป้ายแดง "หยุด" เห็นชัด — และแยกออกจากวันที่ "ยังไม่ได้ลงตาราง" ซึ่งเดิมแสดงเป็นจุดเทาเหมือนกันจนแยกไม่ออก',
      'นำเข้าตารางเวรลงเป็น "ช่วงวันที่" ได้แล้ว เช่น รอบจ่าย 26 ส.ค. – 25 ก.ย. (เดิมลงได้ทีละเดือนปฏิทิน) — ไฟล์ที่ส่งออกจะใส่วันที่เต็มให้เมื่อคร่อมเดือน และช่องที่หลุดช่วงจะถูกรายงาน ไม่ตัดทิ้งเงียบ',
    ],
  },
  {
    version: '1.31.0',
    date: '5 ส.ค. 2569',
    time: '11:20',
    items: [
      'หน้าติดตามรับพนักงานใหม่บอกแล้วว่าใคร "ยังไม่ผูก LINE" — คนกลุ่มนี้ระบบทวงให้ไม่ได้ เพราะช่องทางทวงคือ LINE เอง เดิมกดปุ่มทวงไปก็เงียบโดยไม่รู้สาเหตุ',
      'เพิ่มปุ่ม "ส่งคำเชิญผูก LINE" ในกล่องรายละเอียดของคนที่ยังไม่ผูก — ออกรหัสจับคู่ใหม่พร้อมข้อความเชิญ ส่งต่อทาง LINE หรือคัดลอกไปส่งทางอื่นได้',
      'การทวงพนักงานจะเลือกเฉพาะเรื่องที่พนักงานเป็นคนทำเอง (ส่งเอกสาร เซ็นสัญญา ผูก LINE) ไม่ทวงเรื่องที่ HR เป็นคนทำ เช่น ตั้งฐานเงินเดือน หรือกำหนดแผนก',
    ],
  },
  {
    version: '1.30.0',
    date: '4 ส.ค. 2569',
    time: '21:15',
    items: [
      'เมนูใหม่ "เอกสารตามอายุงาน" — ตอบได้ว่าใครถึงกำหนดต้องทำอะไรบ้างวันนี้ เช่น ประเมินผลทดลองงาน หรือต่อสัญญาจ้าง เรียงคนที่เลยกำหนดขึ้นก่อน กด "จัดการแล้ว" เพื่อเอาออกจากรายการ',
      'ตั้งกฎเองได้ทั้งหมด: จะเตือนเรื่องอะไร นับจากวันไหน (วันเริ่มงาน / วันครบทดลองงาน / วันสิ้นสุดสัญญา) ล่วงหน้ากี่วัน ต้องออกเอกสารอะไร — เพิ่ม แก้ ลบได้เอง ระบบไม่ได้ฝังตัวเลขไว้',
      'ทะเบียนพนักงานเพิ่ม 3 ช่อง: ประเภทสัญญา (จ้างประจำ / มีกำหนดระยะเวลา) · วันสิ้นสุดสัญญา · จำนวนวันทดลองงานรายคน (เว้นว่าง = ใช้ค่าของบริษัท)',
      'คนที่ข้อมูลไม่ครบจนคำนวณกำหนดไม่ได้ จะขึ้นเตือนแยกไว้ พร้อมบอกว่าขาดช่องไหน',
    ],
  },
  {
    version: '1.29.0',
    date: '4 ส.ค. 2569',
    time: '20:05',
    items: [
      'ตรวจพิกัด: ระบบจะไม่ตัดสินว่าพนักงานอยู่นอกพื้นที่ ถ้าเครื่องของเขารายงานความคลาดเคลื่อนมากกว่าระยะที่เกินมา — เช่น วัดได้ห่าง 87 เมตร แต่เครื่องบอกคลาดเคลื่อน ±60 เมตร แปลว่าอาจยืนอยู่ในออฟฟิศจริงก็ได้ ระบบจะไม่เตือนและไม่ส่งให้ HR',
      'พิกัดที่เครื่องบอกว่าคลาดเคลื่อนเกิน 200 เมตร ถือว่าเชื่อถือไม่ได้ ไม่นำมาตัดสินใครทั้งสิ้น',
    ],
  },
  {
    version: '1.28.0',
    date: '4 ส.ค. 2569',
    time: '19:40',
    items: [
      'แก้ไขสำคัญ — เช็คอินอ่านตำแหน่งไม่ได้: ตรวจพบว่าราว 70% ของการเช็คอินที่ผ่านมาไม่มีพิกัดที่ใช้ได้ เพราะแอปขอตำแหน่งแบบหยาบและรอแค่ 6 วินาที ตอนนี้เปลี่ยนเป็นขอตำแหน่งจาก GPS จริงก่อน (รอได้ถึง 12 วินาที) ถ้าไม่ได้ค่อยถอยไปใช้แบบเร็ว',
      'เดิมมีข้อความ "ไม่สามารถระบุพิกัดได้" อยู่แล้ว แต่ถูกล้างทิ้งก่อนขึ้นหน้าจอทุกครั้ง พนักงานเลยไม่เคยเห็น — แก้แล้ว ตอนนี้ถ้าอ่านตำแหน่งไม่ได้จะบอกให้เปิดการเข้าถึงตำแหน่งใน LINE และสแกนในที่โล่ง',
    ],
  },
  {
    version: '1.27.1',
    date: '4 ส.ค. 2569',
    time: '18:55',
    items: [
      'แก้ไข GPS: เช็คอินที่เครื่องอ่านตำแหน่งไม่ได้ (ส่งพิกัด 0,0 มา) จะไม่ถูกนำไปคิดระยะและไม่ถูกนำไปเรียนรู้ที่ตั้งออฟฟิศอีกต่อไป — เดิมทำให้ระบบเสนอพิกัดออฟฟิศผิด',
      'เช็คอินตอนหาสัญญาณ GPS ไม่ได้ ยังบันทึกเวลาให้ตามปกติ (ไม่ลงโทษพนักงาน) แต่จะแจ้งบนหน้าจอและส่งให้ HR ตรวจสอบ ไม่ปล่อยผ่านเงียบ ๆ',
    ],
  },
  {
    version: '1.27.0',
    date: '4 ส.ค. 2569',
    time: '18:25',
    items: [
      'ตรวจพิกัด (GPS): เพิ่มโหมด "เตือน" — พนักงานเช็คอินได้ตามปกติ แต่ถ้าอยู่นอกพื้นที่ ระบบบอกทันทีตรงหน้าจอว่าห่างกี่เมตร พร้อมส่งเข้าคิวให้ HR ตรวจสอบและแจ้ง LINE (เดิมมีแค่ "เรียนรู้" ที่เงียบสนิท กับ "บังคับ" ที่บล็อกไปเลย)',
      'ตั้งค่าพื้นที่ออฟฟิศ: กดใช้พิกัดที่ระบบเรียนรู้มา จะตั้งเป็นโหมด "เตือน" ให้ก่อน ไม่กระโดดไป "บังคับ" ทันที — พิกัดเพิ่งเปลี่ยน ถ้าพลาดแล้วบล็อกเลยพนักงานจะเช็คอินไม่ได้ทั้งบริษัท',
    ],
  },
  {
    version: '1.26.0',
    date: '4 ส.ค. 2569',
    time: '15:10',
    items: [
      'ติดตามรับพนักงานใหม่: ยกเป็นแดชบอร์ดคุมทั้งกอง — บนสุดบอกจำนวน "กำลังรับเข้า / รอเซ็นเอกสาร / เลยกำหนดแล้ว / ครบแล้วรอปิด" กดที่ตัวเลขเพื่อกรองรายชื่อได้ทันที',
      'ตั้งกำหนดวันได้แล้ว: เมนู "ตั้งค่าเช็คลิสต์รับพนักงานใหม่" มีช่อง "ต้องเสร็จภายใน … วัน นับจากวันเริ่มงาน" ทุกรายการ — หน้าติดตามจะบอกเองว่าใครเหลืออีกกี่วัน และใครเลยกำหนดมาแล้วกี่วัน โดยเรียงคนที่ต้องตามก่อนขึ้นบนสุด',
      'ทวงพนักงานทาง LINE: ข้อความบอกกำหนดต่อท้ายทุกรายการ (เช่น "เซ็นสัญญาจ้าง — เลยกำหนด 3 วัน") และเปลี่ยนเป็นโทนด่วนอัตโนมัติเมื่อมีของเลยกำหนด',
      'พนักงานที่ยังไม่ได้ระบุวันเริ่มงานจะขึ้นเตือนไว้ต่างหาก เพราะระบบคำนวณกำหนดวันครบให้ไม่ได้',
    ],
  },
  {
    version: '1.25.0',
    date: '4 ส.ค. 2569',
    time: '13:20',
    items: [
      'พนักงานลาออก: เงินงวดสุดท้ายไม่ตกหล่นอีก — ระบบตัดสินจาก "วันสิ้นสุด" เทียบกับงวดของรอบจ่าย ไม่ใช่สถานะปัจจุบัน คนที่ออกวันที่ 30 ยังอยู่ในรอบค่าคอม/OT ของงวดนั้น (พร้อมป้ายสีแดงบอกวันที่ลาออก) แล้วหายจากงวดถัดไปเองอัตโนมัติ',
      'นำเข้าไฟล์ค่าคอม: แยก "รหัสไม่มีในระบบ" (พิมพ์ผิด) ออกจาก "คนนี้ลาออกไปก่อนงวดนี้" — คนที่ลาออกจะขึ้นกล่องให้ติ๊กยืนยันทีละคนว่าจะจ่ายไหม ไม่ถูกข้ามเงียบเหมือนเดิม',
      'ทะเบียนพนักงาน: เลือกสถานะลาออก/เลิกจ้าง ต้องกรอก "วันสิ้นสุด" ด้วย — ถ้าเว้นว่างคนนั้นจะหายจากทั้งรอบเงินเดือนและรอบจ่ายนอกรอบทันที',
    ],
  },
  {
    version: '1.24.0',
    date: '4 ส.ค. 2569',
    time: '10:45',
    items: [
      'ติดตามรับพนักงานใหม่: การ์ดของแต่ละคนบอกเลยว่า "ยังค้าง" รายการไหน (เช่น ผูกบัญชี LINE, เซ็นสัญญาจ้าง) ไม่ต้องกดเข้าไปดูทีละคนเพื่อหาว่าขาดอะไร',
      'ติดตามรับพนักงานใหม่: เพิ่มปุ่ม "เอาออกจากรายการ" สำหรับคนที่เพิ่มผิดหรือพนักงานทดสอบ — ต่างจาก "จบการรับเข้า" ที่แปลว่ารับเข้าสำเร็จแล้ว · เอาออกแล้วข้อมูลพนักงานและรายการที่ติ๊กไว้ยังอยู่ครบ',
    ],
  },
  {
    version: '1.23.0',
    date: '30 ก.ค. 2569',
    time: '10:17',
    items: [
      'สลิป: แยกเป็นคนละใบแล้ว — สลิปเงินเดือนของงวด = เงินเดือนล้วน · ค่าคอม/OT ที่จ่ายแยกรอบมีสลิปของตัวเอง หน้า "สลิปเงินเดือน" ของพนักงานกางรายการรอบย่อยของแต่ละงวด กดโหลดรายใบได้ทันทีที่รอบนั้นจ่ายแล้ว',
      'หมายเหตุ: สลิปงวดเดิมที่เคยรวมค่าคอมไว้ใบเดียว โหลดใหม่จะเหลือเงินเดือนล้วน — ยอดค่าคอมไม่หาย แค่ย้ายไปอยู่สลิปใบของตัวเอง รวม 2 ใบเท่าเดิม',
      'แก้ไข: ระบบอ่านชื่อเดือนในชื่อรอบจ่ายได้แม้พิมพ์สะกดคลาดเคลื่อน (เช่น "กรกฏาคม") — ไม่เดางวดผิดเดือนอีก',
    ],
  },
  {
    version: '1.22.0',
    date: '29 ก.ค. 2569',
    time: '23:30',
    items: [
      'รอบจ่ายนอกรอบ: ตั้ง "งวด (เดือนที่คิดเงิน)" เองได้ในฟอร์มสร้าง/แก้รอบ — ค่าคอมของเดือนก่อนที่โอนวันที่ 15 จะเข้างวดถูกเดือน ไม่ไหลไปปนสลิปเดือนถัดไป · รายการรอบและหัวรอบแสดงงวดชัดเจน (รอบที่ยังไม่ระบุงวดขึ้นป้ายเหลือง)',
      'แก้ไข: สลิปงวดที่เคยค้างเป็นไฟล์เก่าหลังย้ายงวด/ยกเลิกรอบ — ตอนนี้ระบบสร้างสลิปใหม่ให้เองเสมอเมื่อชุดรอบของงวดเปลี่ยน',
    ],
  },
  {
    version: '1.21.0',
    date: '27 ก.ค. 2569',
    time: '12:39',
    items: [
      'เงินเดือน: ขึ้นแบนเนอร์เตือนเมื่อตัวเลขในงวดยังไม่ตรงกับการตั้งค่าของพนักงาน (เช่น ปลดติ๊ก "เข้าประกันสังคม" แล้วแต่ยอดยังหักอยู่) พร้อมรายชื่อคนและปุ่ม "คำนวณร่างใหม่" ในหน้าเดียว',
      'ชัดเจนขึ้น: ช่อง "หักภาษี ณ ที่จ่าย" ในทะเบียนพนักงานมีผลเฉพาะภาษีเงินเดือน · ภาษี 3% ของค่าคอม/OT ตั้งที่หน้ารอบจ่ายนอกรอบ — ป้ายกำกับบอกไว้ทั้งสองหน้าแล้ว',
      'รอบจ่ายนอกรอบ: คอลัมน์ "หัก ณ ที่จ่าย" แสดงยอดบาทจริงทุกแถวพร้อมบอกที่มา (จากไฟล์ / % ของรอบ) · กติกาการอ่านคอลัมน์นี้จากไฟล์นำเข้าเขียนไว้ข้างปุ่ม และแจ้งหลังนำเข้าว่าอ่านแบบไหน',
    ],
  },
  {
    version: '1.20.1',
    date: '24 ก.ค. 2569',
    time: '17:41',
    items: [
      'ตรวจก่อนปิดงวด: กดรายการที่มีปัญหาแล้วเห็นรายชื่อคนทันที กดชื่อเด้งไปหน้าพนักงานคนนั้นเลย ไม่ต้องไล่หาเอง',
      'แก้ไข: พนักงานที่ตั้ง "ไม่ต้องสแกนเข้างาน / จ่ายเงินเดือนเต็ม" ไม่ถูกขึ้นป้ายขาดงานอีก',
      'แก้ไข: ป้าย "มาทำงานวันไม่ได้กำหนดกะ" หายเองเมื่อ HR ตั้งกะวันนั้นเป็นวันทำงานแล้ว',
    ],
  },
  {
    version: '1.20.0',
    date: '14 ก.ค. 2569',
    time: '21:30',
    items: [
      'เงินเดือน: เพิ่มตัวเลือก "ทำงานวันหยุดประเพณี = คิดเหมือนวันทำงานปกติ" (ตั้งค่า → เงินเดือนและงวด) — เปิดแล้วคนที่มาทำงานวันหยุดตามประเพณีจะได้ค่าจ้าง 1 เท่าเท่าวันทำงานปกติ ระบบไม่บวกค่าทำงานวันหยุด (OT) ให้ · คนที่ไม่มาทำงานยังได้วันหยุดปกติ · ค่าเริ่มต้นปิดไว้ (มีคำเตือนตามกฎหมายแรงงาน ม.62 ใช้เมื่อบริษัทตกลงกับพนักงานแล้ว)',
      'แก้ไข: หน้า "ตั้งค่าพื้นที่ออฟฟิศ (GPS)" ที่ HR เปิดแล้วค้างหมุนตลอด — ตอนนี้ HR เปิดและบันทึกพิกัดได้ปกติ',
      'แก้ไข: หน้าตั้งค่าที่โหลดข้อมูลไม่สำเร็จ จะแสดงข้อความผิดพลาด + ปุ่ม "ลองใหม่" แทนที่จะค้างหมุนโดยไม่บอกอะไร',
    ],
  },
  {
    version: '1.19.0',
    date: '10 ก.ค. 2569',
    time: '19:31',
    items: [
      'เช็คอิน: เพิ่มโหมดตรวจพิกัด 3 แบบ (ปิด / เรียนรู้ / บังคับ) — ตอนนี้ตั้งเป็น "เรียนรู้" พนักงานจึงไม่ติด "รอ HR ตรวจสอบ" อีก ระบบเก็บพิกัดไว้เรียนรู้ที่ตั้งออฟฟิศจากการเช็คอินจริงของหลายคน แล้วเสนอพิกัด+รัศมีให้เจ้าของกดยืนยัน (ระบบไม่เปลี่ยนพิกัดเอง)',
      'เช็คอิน: ตั้งค่าพิกัดออฟฟิศด้วยปุ่ม "ใช้ตำแหน่งปัจจุบัน" ได้แล้ว ไม่ต้องไปหาเลขจาก Google Maps',
      'พนักงาน: เพิ่ม "รูปแบบทำงาน" รายคน — ประจำออฟฟิศ / ทำงานที่บ้าน / ผสม · คนทำงานที่บ้านยังสแกนเข้า-ออกและถ่ายรูปตามปกติ แต่ไม่ถูกตรวจพิกัด',
      'ร้องเรียน: เมื่อพนักงานส่งเรื่องร้องเรียน/ร้องทุกข์/แจ้งเหตุ ระบบแจ้งเตือนเข้า LINE ของ HR และเจ้าของทันที',
      'เอกสาร: หน้าเอกสารพนักงานบอกได้แล้วว่าใครรอเซ็นสัญญาฉบับไหน พร้อมวันเริ่มงาน และดันคนที่ค้างเซ็นนานที่สุดขึ้นบนสุด',
      'สิทธิ์การลา: HR กรอก "ใช้ไปแล้วก่อนเริ่มใช้ระบบ" รายคนได้ (สำหรับคนที่ลาไปก่อนบริษัทเริ่มใช้ระบบนี้) เห็นวันคงเหลือทันทีตอนกรอก',
      'แก้ไข: วันลาครึ่งวันเคยถูกตัดสิทธิ์เป็นเต็มวัน · วันพักร้อนที่ยกยอดจากปีก่อนเคยไม่ถูกบวกเข้าสิทธิ์ — ทั้งสองอย่างแก้แล้ว วันคงเหลือของพนักงานบางคนจะเพิ่มขึ้นให้ถูกต้อง',
      'แก้ไข: การแจ้งเตือนใกล้ปิดงวดเงินเดือนและงานประจำวันของระบบไม่เคยทำงานเลย ตอนนี้ทำงานแล้ว',
    ],
  },
  {
    version: '1.18.6',
    date: '8 ก.ค. 2569',
    time: '22:10',
    items: [
      'รับพนักงานใหม่: เริ่มรับเข้าพนักงานที่สถานะ "รอยืนยันตัวตน" ได้แล้ว (เดิมขึ้นเฉพาะทำงานอยู่/ทดลองงาน) — เก็บเอกสาร/ตั้งค่าก่อนเริ่มงานจริงได้เลย',
    ],
  },
  {
    version: '1.18.5',
    date: '8 ก.ค. 2569',
    time: '21:40',
    items: [
      'พนักงาน: หน้าแก้ไขโชว์ "กรอกข้อมูลแล้ว X%" + ปุ่ม "แจ้งเตือนให้กรอก" (ส่ง LINE ให้พนักงานเข้ามากรอกข้อมูล/แนบเอกสารให้ครบ เมื่อยังไม่ครบ 100%)',
      'รับพนักงานใหม่: โมดอล "เลือกพนักงานที่จะเริ่มรับเข้า" ค้นหาชื่อ/รหัสพนักงานได้แล้ว',
    ],
  },
  {
    version: '1.18.4',
    date: '8 ก.ค. 2569',
    time: '21:20',
    items: [
      'เอกสาร: เอกสารบังคับ 3 อย่าง (บัตรประชาชน / สำเนาทะเบียนบ้าน / สมุดบัญชีธนาคาร) ติดป้าย "บังคับ" ในแท็บเอกสาร · เอกสารอื่นขึ้น "ถ้ามี" (แนบได้ถ้ามี) · ตารางติดตาม + ปุ่มทวงครอบสมุดบัญชีธนาคารด้วยแล้ว',
    ],
  },
  {
    version: '1.18.3',
    date: '8 ก.ค. 2569',
    time: '21:00',
    items: [
      'พนักงาน: รวมเรื่องเงินไว้แท็บเดียว "การเงิน" — เงินเดือน/ธนาคาร · ภาษี/ประกันสังคม · ค่าคอม/การจ่าย · เงินเพิ่ม/เงินหัก (เหลือ 9 แท็บ ดูง่ายขึ้น)',
    ],
  },
  {
    version: '1.18.2',
    date: '8 ก.ค. 2569',
    time: '20:40',
    items: [
      'พนักงาน: หน้าแก้ไขแบ่งเป็นแท็บย่อยให้ดูง่าย ไม่ยาวรวด — ส่วนตัว / การติดต่อ / งาน / ภาษี-ประกันสังคม / ค่าคอม-การจ่าย / เงินเพิ่ม-หัก / วันหยุด-ตารางเวร / วันลาคงเหลือ / การศึกษา / เอกสาร / ระบบ',
      'พนักงาน: เพิ่มแท็บ "วันลาคงเหลือ" แสดงสิทธิ์วันลาปีนี้ (ป่วย/กิจ/พักร้อน + ยกมา)',
    ],
  },
  {
    version: '1.18.1',
    date: '8 ก.ค. 2569',
    time: '20:00',
    items: [
      'พนักงาน: หน้าแก้ไข (เต็มจอ) ยังเห็นเมนูซ้ายอยู่ ไม่บังทั้งจอ',
      'เอกสาร: แท็บเอกสารแสดงเป็นช่องตามชื่อเอกสารที่ต้องมี — บัตรประชาชน / สำเนาทะเบียนบ้าน / Transcript / ใบตรวจร่างกาย / สัญญาจ้าง / สัญญาแนบท้าย · แต่ละช่องกดแนบไฟล์ได้เลย เห็นว่ามี/ยังไม่มี + แนบซ้ำเก็บเป็นเวอร์ชันใหม่',
    ],
  },
  {
    version: '1.18.0',
    date: '8 ก.ค. 2569',
    time: '18:30',
    items: [
      'รับพนักงานใหม่: เมนูใหม่ "รับพนักงานใหม่" — เช็คลิสต์ที่ตั้งค่าได้ (เอกสารที่ต้องส่ง / ตั้งค่าที่ต้องทำ / เอกสารที่ต้องเซ็น) · ระบบติ๊กให้อัตโนมัติเมื่อพนักงานอัปโหลดเอกสาร/ตั้งเงินเดือน/ผูก LINE/เซ็นสัญญา · พนักงานสร้างใหม่โผล่ในแดชบอร์ดเอง + หน้า "สิ่งที่ต้องทำ" ฝั่งพนักงาน',
      'พนักงาน: หน้าแก้ไขข้อมูลเป็นแบบเต็มจอ (แทนหน้าต่างเล็ก) + แยกแท็บ "ข้อมูลพนักงาน" กับ "เอกสาร" ให้ดูง่ายขึ้น',
      'เอกสาร: แยกเอกสารส่วนตัวพนักงาน (ทวงได้) ออกจากเอกสารบริษัท เช่น สัญญาจ้าง (ไม่ทวง)',
    ],
  },
  {
    version: '1.17.0',
    date: '8 ก.ค. 2569',
    time: '16:00',
    items: [
      'เอกสารพนักงาน: เมนูใหม่ "เอกสารพนักงาน" (เจ้าของ/HR) — เก็บเอกสารรายคนแบบมีประวัติเวอร์ชัน (บัตรประชาชน/ทะเบียนบ้าน/สัญญาจ้าง/หนังสือเตือน/เลิกจ้าง) พร้อมวันเวลาที่อัปโหลด · ตารางติดตามว่าใครยังขาดเอกสารอะไร + ปุ่มทวงผ่าน LINE',
      'เอกสารพนักงาน: สร้างสัญญาจ้างจากข้อมูลในระบบแล้วส่งให้พนักงานเซ็นได้เลย — พนักงานเซ็นบนจอในแอป หรืออัปรูปเอกสารที่เซ็นแล้ว (บันทึกวันเวลาที่เซ็น)',
      'เงินเดือน: ตั้ง "มีค่าคอมมิชชั่น" รายคนได้ — คนมีค่าคอม งวดเงินเดือนจ่ายแค่ฐาน + ภาษี/ปกส. ส่วนรายการหัก (สาย/ลา/ขาด) + OT + เงินเพิ่ม/หัก ย้ายไปหักตอนจ่ายค่าคอม (หน้าเงินเดือนสรุปยอดที่ต้องย้ายให้) · คนไม่มีค่าคอม = หักจากเงินเดือนตามเดิม',
      'เงินเดือน: แก้ปุ่ม "หักภาษี ณ ที่จ่าย" รายคน ที่เดิมติ๊กแล้วไม่บันทึก — ตอนนี้บันทึกได้จริง',
    ],
  },
  {
    version: '1.16.0',
    date: '2 ก.ค. 2569',
    time: '00:40',
    items: [
      'เงินเดือน: นำเข้าไฟล์แล้ว "พักคนที่ไม่อยู่ในไฟล์" อัตโนมัติ (ไม่คิดเงินเดือนงวดนั้น) — ไฟล์นำเข้าเป็นตัวกำหนดว่าใครได้เงินเดือนงวดนี้ · หน้ายืนยันบอกจำนวนคนที่จะพัก · นำเข้าไฟล์ที่มีชื่อเขาอีกครั้ง = กลับมาคิดปกติ',
      'เงินเดือน: โหมด "ไม่คิดภาษี/ประกันสังคมอัตโนมัติ" — ปิดการจำกัดหักตามมาตรา 76 (หักได้เต็มตามที่กรอกในไฟล์ ไม่มียอดยกไปงวดหน้า)',
      'เงินเดือน: แก้บั๊กนำเข้าเงินเดือนแล้วค่าเก่าไม่อัปเดต (ล้างแถวเงินเดือนเก่าที่ทับซ้อนก่อนลงค่าใหม่)',
    ],
  },
  {
    version: '1.15.0',
    date: '1 ก.ค. 2569',
    time: '22:30',
    items: [
      'เงินเดือน: ปุ่ม "เทมเพลต" ดาวน์โหลดเป็น Excel (.xlsx) พร้อม 3 คอลัมน์สรุปท้ายตาราง — รวมรายได้ / รวมรายการหัก / คงเหลือสุทธิ (สูตรคำนวณอัตโนมัติ) → กรอกตัวเลขแล้วเห็นสุทธิทันที ตรวจง่ายก่อนอัพโหลด · ตอนนำเข้าระบบข้ามคอลัมน์สรุปให้เอง',
      'เงินเดือน: นำเข้าเร็วขึ้นมาก (ตั้งเงินเดือนหลายคนพร้อมกัน) + นำเข้าซ้ำไม่เกิดรายการซ้ำสะสมอีก (ลบของเดิมก่อนลงใหม่)',
    ],
  },
  {
    version: '1.14.0',
    date: '1 ก.ค. 2569',
    time: '15:30',
    items: [
      'เงินเดือน: นำเข้าไฟล์แบบ "แจงรายการ" — ในไฟล์เดียว ใส่คอลัมน์ "เพิ่ม:ชื่อ" (เงินเพิ่ม) และ "หัก:ชื่อ" (เงินหัก) ได้ไม่จำกัด เช่น หัก:ประกันสังคม / หัก:ภาษี / หัก:หัก 3% / เพิ่ม:ค่าคอม — แต่ละคอลัมน์ = 1 บรรทัดในสลิป (แจงให้เห็นครบ) · เพิ่ม/ลบคอลัมน์เองได้',
      'ตั้งค่า: เพิ่มโหมด "ไม่คิดภาษี/ประกันสังคมอัตโนมัติ (กรอกเองในไฟล์)" — เปิดแล้วระบบจะไม่คำนวณ ภาษี/ปกส./PF ให้ ใช้ตัวเลขจากไฟล์นำเข้าล้วน · สุทธิ = เงินเดือน + เงินเพิ่มที่กรอก − เงินหักที่กรอก (คุมยอดเองทั้งหมด ตรง Excel เป๊ะ)',
    ],
  },
  {
    version: '1.13.0',
    date: '1 ก.ค. 2569',
    time: '10:00',
    items: [
      'พนักงาน: เพิ่มช่องติ๊ก "เข้าประกันสังคม (หัก 5%)" รายคน (ในหน้าแก้ไขพนักงาน ใต้เลขประกันสังคม) — ติ๊ก = ระบบหัก ปกส. 5% (สูงสุด 875 บ./เดือน) อัตโนมัติทุกงวด · เอาออก = คนนี้ไม่หัก ปกส. · ค่าเริ่มต้น = เข้าทุกคน · ค่านี้ไม่หายเวลาปรับเงินเดือน',
      'เงินเดือน (เจ้าของ + HR): นำเข้า "ไฟล์เดียว" ตั้งเงินเดือน + เงินเพิ่ม + เงินหัก ได้พร้อมกัน — กด "เทมเพลต" ที่การ์ด "นำเข้าเงินเดือน + เงินเพิ่ม/หัก" → กรอกช่องเงินเดือน/เงินเพิ่ม/เงินหักใน Excel → เลือก "วันที่มีผล" ของเงินเดือน (ปกติ = วันที่ 1 ของงวด) → กด "นำเข้าไฟล์" → ระบบตั้งฐานเงินเดือน และลงเงินเพิ่ม/หักให้ทุกคนทีเดียว · เว้นช่องเงินเดือนว่าง = ไม่แก้ของเดิม · เสร็จแล้วกด "โหลดข้อมูล" แล้ว "รันร่างใหม่"',
    ],
  },
  {
    version: '1.12.0',
    date: '29 มิ.ย. 2569',
    time: '23:00',
    items: [
      'เงินเดือน: ใส่เงินเพิ่ม/เงินหัก "หลายคนพร้อมกัน" ได้แล้ว — กด "เทมเพลต" เพื่อโหลดรายชื่อพนักงานล่าสุด → กรอกช่องเงินเพิ่ม/หักใน Excel → กด "นำเข้าหลายคน" → ระบบลงให้ทุกคนทีเดียว (เดิมต้องกดทีละคน) แล้วกดรันร่างใหม่เพื่ออัปเดตตัวเลข',
    ],
  },
  {
    version: '1.11.0',
    date: '28 มิ.ย. 2569',
    time: '11:30',
    items: [
      'เพิ่มเมนู "ขอเปลี่ยนกะการทำงาน" (พนักงาน) — ขอเปลี่ยนกะของตัวเองในวันหนึ่ง เช่น เข้า 08:00 → เข้า 12:00 · อนุมัติ 2 ชั้น (หัวหน้า → HR) เหมือนย้ายวันหยุด · ถ้ากระชั้น (ไม่ครบล่วงหน้า 1 วัน) = กระทันหัน ต้องระบุเหตุผล ให้ HR อนุมัติ · อนุมัติแล้วเขียนทับกะของวันนั้นให้อัตโนมัติ',
      'ปฏิทินเวรทีม: แก้ให้ HR/เจ้าของเห็นเวรพนักงานครบทุกคน "เต็มเดือน" (เดิมถ้าข้อมูลเวรเยอะจะแสดงไม่ครบ)',
      'ตั้งค่าเวลา: ช่อง "วันหยุดประจำสัปดาห์" เว้นว่างได้ = บริษัททำงานทุกวัน ไม่มีวันหยุดประจำสัปดาห์',
    ],
  },
  {
    version: '1.10.0',
    date: '26 มิ.ย. 2569',
    time: '11:30',
    items: [
      'ขอย้ายวันหยุด: รองรับสายอนุมัติ 2 ชั้น — หัวหน้าอนุมัติแล้ววิ่งต่อให้ผู้อนุมัติชั้น 2 (เช่น HR) ยืนยันอีกที (ตั้งจำนวนชั้นที่ "ตั้งค่าสายอนุมัติ"); พนักงานที่ไม่มีหัวหน้าให้ HR/เจ้าของอนุมัติชั้นเดียว',
      'แจ้งเตือนเจ้าของเข้า LINE "ทุกครั้ง" ที่มีคำขอใหม่ (ลา / OT / ย้ายวันหยุด) — เปิด/ปิดได้ที่ "ตั้งค่าการแจ้งเตือน"',
      'แก้กะกลางคืน (ข้ามวัน) ที่เคยบันทึกเวลาเข้า–ออกสลับกัน — เข้าตอนดึก/ออกตอนเช้าจะลงวันเดียวกันถูกต้อง คิดชั่วโมงตรง',
      'ดาวน์โหลดเทมเพลตตารางเวร: ได้ "ตารางเปล่า" ของเดือนที่เลือก (ไม่ดึงกะเดือนก่อนมาใส่ให้)',
      'เพิ่มเมนู "เจ้าของระบบ (Owner)" — เจ้าของตั้งคนอื่นเป็นเจ้าของเพิ่มได้ (หลายคน) เฉพาะเจ้าของเท่านั้นที่ทำได้',
      'พนักงานที่ลาออก/พ้นสภาพ: ตัดออกจากไฟล์จัดกะอัตโนมัติ + ลบกะ/คำขอในอนาคตที่ค้าง ไม่ให้ค้างในปฏิทินเวร',
    ],
  },
  {
    version: '1.9.0',
    date: '21 มิ.ย. 2569',
    time: '16:43',
    items: [
      'หัวหน้างาน (Supervisor) เห็นเมนูจัดการทีม (เข้างานวันนี้ / ประวัติเข้างานรายคน / กะการทำงาน / นำเข้าตารางเวร / แดชบอร์ด) — ดูได้เฉพาะลูกทีมในสายบังคับบัญชาตัวเอง',
      'เปลี่ยนชื่อบริษัทเป็น "มั่งมีทรัพย์168" ทั้งในระบบและเอกสาร (สลิป / หนังสือรับรอง)',
      'ล็อกการเช็คอิน–เช็คเอาท์ กันกดซ้ำ (เข้างาน/เลิกงาน บันทึกได้ครั้งเดียวต่อวัน) — ถ้าผิดพลาดใช้เมนู "รับรองเวลาเข้างาน" แทน',
      'เพิ่มเมนู "รับรองเวลาเข้างาน" — พนักงานขอแก้/รับรองเวลาเข้า-ออกงาน (ลืมตอก/ตอกผิด) แล้วให้ HR อนุมัติ',
      'จัดกะ: เตือน + บล็อกการลงเวรทำงานทับวันที่พนักงานลาไว้แล้ว (ลาทุกประเภทที่อนุมัติแล้ว) — มีป้าย "ลา" ในปฏิทินเวร',
      'ขอย้ายวันหยุด: เลือกกะของวันที่กลับมาทำงานได้ + ถ้าแจ้งกระชั้น (ไม่ครบล่วงหน้า 1 วัน) ระบบจะตั้งเป็น "กระทันหัน" ต้องระบุเหตุผล และให้ HR อนุมัติ',
    ],
  },
  {
    version: '1.8.0',
    date: '19 มิ.ย. 2569',
    time: '12:30',
    items: [
      'เพิ่มเมนู "หนังสือรับรอง" — ออกหนังสือรับรองการทำงาน / รับรองเงินเดือน เป็น PDF (หัวบริษัท + โลโก้ + ลายเซ็น)',
      'แก้บั๊กสลิปงวดที่จ่ายค่าคอมแล้วแต่ยังขึ้น "พรีวิว · รอค่าคอม" — ตอนนี้โหลดสลิปได้ทุกคนเมื่อบริษัทจ่ายค่าคอมงวดนั้นครบ',
      'หน้าลาออก/เลิกจ้าง: เพิ่มปุ่ม "ออกจากงานเลย" กดแล้วระบบคำนวณให้ทันทีแล้วให้ยืนยัน (หรือกด "คำนวณดูก่อน" ตรวจยอดก่อนก็ได้)',
    ],
  },
  {
    version: '1.7.0',
    date: '18 มิ.ย. 2569',
    time: '23:56',
    items: [
      'หน้าลาออก/เลิกจ้าง: บันทึกแล้วเด้งป๊อปอัป "บันทึกข้อมูลการลาออกสำเร็จ" แล้วล้างฟอร์มให้พร้อมทำคนต่อไป',
      'ฝ่ายบุคคล (HR) เพิ่มพนักงานได้แล้ว — เมนูเพิ่มพนักงาน / นำเข้าพนักงาน (Excel, ชื่อ+เลขบัตร) เปิดให้ HR',
    ],
  },
  {
    version: '1.6.0',
    date: '17 มิ.ย. 2569',
    time: '21:53',
    items: [
      'แดชบอร์ด: เพิ่มการ์ดสรุป Top 5 พนักงานมาสาย / ลางาน ของงวด (เลือกเดือนได้)',
      'เพิ่มป้ายเวอร์ชัน + ประวัติการอัปเดตระบบ (มุมล่าง sidebar)',
    ],
  },
  {
    version: '1.5.0',
    date: '17 มิ.ย. 2569',
    time: '21:38',
    items: [
      'แจ้งเตือนเจ้าของ (รับทราบ) เมื่ออนุมัติใบลา/OT เสร็จ — เป็น LINE flex card',
      'เพิ่มเมนูตั้งค่าแจ้งเตือนของเจ้าของ (เปิด/ปิดรายเรื่องได้)',
    ],
  },
  {
    version: '1.4.0',
    date: '17 มิ.ย. 2569',
    time: '21:00',
    items: [
      'สลิปเงินเดือนรวมเป็น "งวดเดียว" (เงินเดือน + ค่าคอม) — โหลดได้เมื่อจ่ายค่าคอม หรือ HR อนุมัติออกสลิป',
      'วันหยุดประเพณี = วันทำงาน (ไม่แสดงเป็นวันหยุด · มาทำงานได้ค่าแรง +1 เท่า)',
      'หัวหน้างานจัดกะได้เฉพาะทีมในสายงานตัวเอง (เมนู "จัดกะทีมงาน")',
    ],
  },
  {
    version: '1.3.0',
    date: '16 มิ.ย. 2569',
    time: '14:00',
    items: [
      'สลิปเงินเดือนออกแบบใหม่ — เอกสารทางการ ขาว-ดำ + โลโก้บริษัท',
      'สลิปขึ้นหัวตามประเภท: "สลิปค่าคอมมิชชั่น" / "สลิปเงินเดือน"',
      'แก้บั๊กปฏิทิน: วันหยุดที่ลงไว้แสดงเป็นวันหยุดถูกต้อง (ทั้งปฏิทินและเงินเดือน)',
    ],
  },
  {
    version: '1.2.0',
    date: '16 มิ.ย. 2569',
    time: '11:00',
    items: [
      'หน้า "ประวัติการจ่ายเงินเดือน" รวมเงินเดือน + ค่าคอมไว้ที่เดียว',
      'แสดงชื่อ-นามสกุลพนักงาน (เดิมแสดงแต่รหัส) · คลิกชื่อดูสลิปเป็น popup',
    ],
  },
  {
    version: '1.1.0',
    date: '16 มิ.ย. 2569',
    time: '09:00',
    items: [
      'นำเข้าเงินเดือน + ค่าคอม งวดพฤษภาคม 2569 เข้าระบบ',
      'รวมเมนูสลิปของพนักงานเป็น "สลิปเงินเดือน" เมนูเดียว',
    ],
  },
];

const latest = CHANGELOG[0]!;
export const APP_VERSION = latest.version;
export const LAST_UPDATED = `${latest.date} ${latest.time} น.`;
